/**
 * PMDocumentValidationSummaryCard — PM-facing published Document Validation report.
 * Phase E.1 (2026-02): banner is human-selected by NTN staff.
 */
import { ShieldCheck } from "lucide-react";
import VerifiedReport from "./VerifiedReport";

function normalizeBullets(bullets = []) {
  return bullets.map((b) => ({ ...b, value: b.verified || b.claimed || "—" }));
}

export default function PMDocumentValidationSummaryCard({ screening, testid = "pm-documents-summary" }) {
  const summary = screening?.verifications?.documents?.pm_summary;
  if (!summary || !summary.published_at) return null;
  const payload = {
    ...summary,
    status_banner: summary.status_banner || null,
    narrative: summary.narrative || "",
    bullets: normalizeBullets(summary.bullets),
    risk_indicators: summary.risk_indicators || [],
  };
  return (
    <VerifiedReport
      moduleName="Document Validation"
      title="Verified Document Validation Report"
      Icon={ShieldCheck}
      payload={payload}
      testid={testid}
      sectionLabel="Documents Reviewed"
    />
  );
}
